<template>
    <section
        v-if="display"
        class="statement-blue-bar"
    >
        <BaseButton
            class="statement-blue-bar__close-button"
            @click.native="close"
        >
            {{ closeButtonText }}
        </BaseButton>
        <div><slot /></div>
    </section>
</template>

<script>
import BaseButton from '~/components/common/Button/BaseButton';
import {
    getState as getStateCookiesStatement,
    set as setCookiesStatement,
} from '~/assets/services/storages/cookies/cookiesStatement';

export default {
    name: 'StatementBlueBar',
    components: {
        BaseButton,
    },
    props: {
        statementId: {
            type: String,
            required: true,
        },
        closeButtonText: {
            type: String,
            default: 'Zamknij',
        },
    },
    data() {
        return {
            display: null,
        };
    },
    watch: {
        display(displayState) {
            this.$emit('display-changed', displayState);
        },
    },
    mounted() {
        this.display = !getStateCookiesStatement({ id: this.statementId });
    },
    methods: {
        close() {
            setCookiesStatement({ id: this.statementId });
            this.display = false;
        },
    },
};
</script>

<style lang="scss">
    .statement-blue-bar {
        width: 100%;
        color: $color-castoWhite;
        font: $font-weight-regular 14px/18px $goodHomeFontFamily;
        position: relative;
        padding: $spacing-default;
        @include colored-icon('info', darken($color-castoBlue, 2%));
        background-color: $color-castoBlue;
        top: 0;
        background-size: auto 240px;
        background-position: calc(100% - 25px) -30px ;
        background-repeat: no-repeat;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        text-transform: uppercase;
        min-height: 100px;

        &__close-button {
            color: $color-castoBlue;
            border: none;
            @include colored-icon('close-x', $color-castoWhite);
            background-repeat: no-repeat;
            background-size: 14px 14px;
            width: 30px;
            height: 30px;
            text-indent: -9999px;
            cursor: pointer;
            position: absolute;
            right: 0;
            top: 0;
            opacity: 70%;
        }
    }
    @media (min-width: $mf-breakpoint-tablet) {
        .statement-blue-bar {
            font: $font-weight-regular 24px/32px $goodHomeFontFamily;
            min-height: 135px;
            background-size: auto 320px;
            background-position: calc(100% - 45px) -40px ;

            &__close-button {
                background-size: 11px 11px;
                opacity: 50%;

                &:hover {
                    opacity: 100%;
                }
            }
        }
    }
</style>
